// Compare app

(function () {

    // ── Scale/Balance SVG icon ──
    var ICON_SVG = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="24" fill="#F5F5F4"/>
<path d="M15 18L18 19M18 19L15 28C16.7725 29.3334 19.2287 29.3334 21.0012 28M18 19L21.0001 28M18 19L24 17M30 19L33 18M30 19L27 28C28.7725 29.3334 31.2287 29.3334 33.0012 28M30 19L33.0001 28M30 19L24 17M24 15V17M24 33V17M24 33H21M24 33H27" stroke="#3F3F46" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

  function wrapCompareButton(originalBtn) {
  if (originalBtn.dataset.wrapped) return;
  originalBtn.dataset.wrapped = 'true';

  // ── Pehle container mein saare purane custom buttons remove karo ──
  var container = originalBtn.closest('.product-form__buttons');
  if (container) {
    container.querySelectorAll('.custom-compare-btn').forEach(function(btn) {
      btn.remove();
    });
  }

  var customBtn = document.createElement('button');
  customBtn.className = 'custom-compare-btn';
  customBtn.setAttribute('aria-label', 'Add to Compare');
  customBtn.setAttribute('title', 'Add to Compare');
  customBtn.innerHTML = ICON_SVG;
  customBtn.type = 'button';

  originalBtn.parentNode.insertBefore(customBtn, originalBtn);

  customBtn.addEventListener('click', function () {
    originalBtn.click();
    customBtn.classList.toggle('is-added');
  });
}

    function init() {
      document.querySelectorAll('.coder-compareder-compare.coder-compare-button')
        .forEach(wrapCompareButton);

      // Dynamically load hone wale buttons ke liye
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.coder-compareder-compare.coder-compare-button')) {
              wrapCompareButton(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('.coder-compareder-compare.coder-compare-button')
                .forEach(wrapCompareButton);
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

  })();









// Accordion Animation


(function () {
  function initAccordions() {
    document.querySelectorAll('.accordion details').forEach(function (details) {
      var content = details.querySelector('.accordion__content');
      if (!content || content.dataset.animated) return;
      content.dataset.animated = 'true';

      // Initial state
      content.style.height = details.open ? content.scrollHeight + 'px' : '0px';

      details.querySelector('summary').addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          // Closing
          content.style.height = content.scrollHeight + 'px';
          content.offsetHeight;
          content.style.height = '0px';
          content.addEventListener('transitionend', function handler() {
            details.removeAttribute('open');
            content.removeEventListener('transitionend', handler);
          });
        } else {
          // Opening
          details.setAttribute('open', '');
          var h = content.scrollHeight + 'px';
          content.style.height = '0px';
          content.offsetHeight;
          content.style.height = h;
          content.addEventListener('transitionend', function handler() {
            content.style.height = 'auto';
            content.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
})();






